import { NavLink } from "react-router-dom";
import { Calculator, History, Users, Settings } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/lib/i18n";

const nav = [
  { to: "/", key: "nav_new_count", icon: Calculator, testid: "nav-new-count", end: true },
  { to: "/history", key: "nav_history", icon: History, testid: "nav-history" },
  { to: "/employees", key: "nav_employees", icon: Users, testid: "nav-employees" },
  { to: "/settings", key: "nav_settings", icon: Settings, testid: "nav-settings" },
];

export const Layout = ({ children }) => {
  const { account } = useAuth();
  const t = useT();
  return (
    <div className="min-h-screen bg-background pb-24 sm:pb-0">
      <header className="sticky top-0 z-40 border-b border-border bg-card/90 backdrop-blur">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary text-primary-foreground">
              <Calculator className="h-5 w-5" />
            </div>
            <div className="leading-tight">
              <span className="block font-display text-xl font-extrabold tracking-tight text-foreground">
                TilloCash
              </span>
              {account && (
                <span
                  className="block text-xs font-semibold text-muted-foreground"
                  data-testid="header-business-name"
                >
                  {account.business_name}
                </span>
              )}
            </div>
          </div>
          <nav className="hidden items-center gap-1 sm:flex">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={n.testid}
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-xl px-3 py-2 text-sm font-semibold transition-colors duration-200 ${
                    isActive
                      ? "bg-primary text-primary-foreground"
                      : "text-muted-foreground hover:bg-secondary hover:text-foreground"
                  }`
                }
              >
                <n.icon className="h-4 w-4" />
                {t(n.key)}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-6">{children}</main>

      <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-border bg-card sm:hidden">
        <div className="mx-auto flex max-w-3xl items-stretch justify-around">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`${n.testid}-mobile`}
              className={({ isActive }) =>
                `flex flex-1 flex-col items-center gap-1 py-2.5 text-xs font-semibold transition-colors duration-200 ${
                  isActive ? "text-primary" : "text-muted-foreground"
                }`
              }
            >
              <n.icon className="h-5 w-5" />
              {n.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
};
